import {all} from 'redux-saga/effects';
import userSagas from './user/sagas';
import coursesSagas from './course/sagas';
import groupsSaga from './group/sagas';
import organisationSaga from './organisation/sagas';
import attestationSaga from './attestation/sagas';
export default function* rootSaga() {
    yield all([
        ...userSagas,
        ...coursesSagas,
        ...groupsSaga,
        ...organisationSaga,
        ...attestationSaga,
    ])
};
